import React, { PureComponent } from 'react'
import { object } from 'prop-types'
import { RaceSimulation } from 'components'

import './Race.css'

export class RaceTabResults extends PureComponent {
    static propTypes = {
        data: object.isRequired
    }

    render() {
        const { data: { players = [], numberOfSegments, raceTime } = {} } = this.props
        return (
            <div className="RaceTabResults h-100">
                <RaceSimulation cars={players} numberOfSegments={numberOfSegments} raceTime={raceTime} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/Race/RaceTabResults.js